<template>
  <div class="upload-file">
    <div class="preview-list">
      <div :key="preview" :style="previewStyle" class="preview-item" v-for="preview in list">
        <div class="preview-cover" v-if="disabled"></div>
        <slot name="preview">
          <div :style="previewStyle">
            <comp-imger :src="preview"></comp-imger>
          </div>
        </slot>
        <slot name="hover" v-if="!disabled">
          <div :style="previewStyle" class="preview-del">
            <div class="preview-box">
              <div @click="onClickImg(preview)" class="preview-text">删除</div>
              <div @click="onClickPreviewImg(preview)" class="preview-text">预览</div>
            </div>
          </div>
        </slot>
      </div>
      <div class="trigger-container" :style="previewStyle" ref="addBtn" v-show="!hideUpLoadTrigger">
         <label
          :for="`${counter}${previews.length}`"
          :style="previewStyle">
          <slot name="trigger">
            <div :style="previewStyle" class="upload-trigger">+</div>
          </slot>
        </label>
      </div>
    </div>

    <input
      :accept="accept"
      :id="`${counter}${index}`"
      :key="`${index}${counter}`"
      @change="onChange"
      :multiple="limit === 1 ? false : true"
      hidden
      type="file"
      v-for="(i, index) in (previews.length + 1)"
    >
  </div>
</template>

<script>
/**
 * TODO:
 * 文件类型
 * 大小限制
 * 文件剪裁
 */
import frame from '../frame';
import { uuid } from '../../tools';
import config from '../../../config.js';

/**
 * accept  mimetype
 * limit   限制图片上传数量
 * single  只允许上传单张图片
 * action
 * value   图片链接 string | array
 * fileurl 文件服务器前缀
 *
 * Event
 *
 * input
 * success
 */

export default {
  inject: {
    elForm: {
      default: ''
    },
    elFormItem: {
      default: ''
    }
  },
  props: {
    accept: {
      type: String
    },
    limit: {
      type: Number,
      default: 1,
      required: true,
    },
    value: {
      default: ''
    },
    fileurl: {
      default: ''
    },
    width: {
      default: 120
    },
    height: {
      default: 120
    }
  },
  watch: {
    value(value) {
      let previews = [];

      if (typeof value === 'string' && value) {
        previews.push(value);
      }

      if (Object.prototype.toString.apply(value) === '[object Array]') {
        previews = value;
      }
      this.previews = previews;
    }
  },
  computed: {
    list() {
      return this.previews.length ? this.previews : [];
    },
    hideUpLoadTrigger() {
      return this.limit <= this.previews.length;
    },
    disabled() {
      return this.elForm.disabled || this.elFormItem.disabled;
    }
  },
  data() {
    let previews = [];
    if (typeof this.value === 'string' && this.value) {
      previews.push(this.value);
    }

    if (Object.prototype.toString.apply(this.value) === '[object Array]') {
      previews = this.value;
    }

    const width = typeof this.width === 'string' ? this.width : `${this.width}px`;
    const height = typeof this.height === 'string' ? this.height : `${this.height}px`;
    const fontSize = `${Number(Math.max(width.replace('px', ''), height.replace('px', ''))) / 5}px`;

    return {
      previews,
      previewStyle: {
        width,
        height,
        fontSize
      },
      counter: uuid(),
      loading: null
    };
  },
  methods: {
    onClickImg(url) {
      this.counter = uuid();
      const index = this.previews.findIndex(item => item === url);
      this.previews.splice(index, 1);

      this.$emit('input', this.previews);
    },
    onClickPreviewImg(url) {
      if (this.accept) {
        frame.show({
          src: url,
          type: this.accept
        });
      } else {
        frame.show({
          src: url
        });
      }
    },
    onChange(e) {
      if (e.target.files.length > this.limit) {
        this.$message(`限制为${this.limit}个文件`);
        return;
      }

      [...e.target.files].forEach(f => this.upload(f))
    },
    upload (file) {
      this.loading = this.$loading({
        target: this.$refs.addBtn
      })

      const formData = new FormData();

      formData.append('file', file);

      fetch('https://'+config.domain+'/up', {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json'
        }
      })
        .then(response => {
          if (this.loading) this.loading.close()
          this.loading = null
          return response.json()
        })
        .then(data => {
          const url = `${this.fileurl}${data.file}`;
          this.previews.push(url);
          if (this.limit === 1) {
            this.$emit('input', url);
            this.$emit('success', url);
          } else {
            this.$emit('input', this.previews);
            this.$emit('success', this.previews);
          }
        })
        .catch(() => {
          if (this.loading) this.loading.close()
          this.loading = null
        })
    }
  }
};
</script>

<style>
.trigger-container > .el-loading-mask {
  display: none;
}
.preview-box {
  display: flex;
  flex-direction: column;
}
.preview-text {
  text-align: center;
  display: flex;
  height: 20px;
  width: 120px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.preview-text:hover {
  font-size: 14px;
}
.preview-list {
  display: flex;
  flex-wrap: wrap;
}
.preview-item {
  width: 120px;
  height: 120px;
  margin-right: 10px;
  margin-bottom: 10px;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.preview-item img {
  width: 120px;
  height: 120px;
}
.upload-file {
  display: flex;
}
.trigger-container {
  display: inline-block;
  border: 1px dashed #d8d8d8;
  font-size: 0;
  width: 118px;
  height: 118px;
  border-radius: 4px;
}
.upload-trigger {
  display: block;
  width: 120px;
  height: 120px;
  color: #888;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 15px;
}

.preview-del {
  position: absolute;
  top: 0;
  left: 0;
  width: 120px;
  height: 120px;
  color: #fff;
  background-color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  border-radius: 4px;
  opacity: 0;
}
.preview-item:hover .preview-del {
  opacity: 1;
}
.preview-cover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(221, 218, 218, 0.5);
}
</style>
